import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row secret-data-ssh" }
const _hoisted_2 = { class: "col span-6 username" }
const _hoisted_3 = { class: "col span-6 password" }


import DetailText from '@shell/components/DetailText.vue';

export interface Props {
    username?: string;
    password?: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Ssh',
  props: {
    username: {},
    password: {}
  },
  setup(__props: any) {

const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(DetailText, {
        value: props.username,
        "label-key": "secret.ssh.public"
      }, null, 8, ["value"])
    ]),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(DetailText, {
        value: props.password,
        "label-key": "secret.ssh.private",
        conceal: true,
        "conceal-stand-alone": true
      }, null, 8, ["value"])
    ])
  ]))
}
}

})